module.exports = __webpack_public_path__ + "media/images/logo-square-3fb0dff2f85d5b399687a8829b5bf7e4.png";